module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "operationForm",
    attrs: {
      "model": _vm.operationData,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "关联功能",
      "prop": "type"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.operationData.id),
      expression: "operationData.id"
    }],
    attrs: {
      "placeholder": "请选择关联功能"
    },
    domProps: {
      "value": (_vm.operationData.id)
    },
    on: {
      "input": function($event) {
        _vm.operationData.id = $event
      }
    }
  }, _vm._l((_vm.selection), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "位置",
      "prop": "pos"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.operationData.pos),
      expression: "operationData.pos"
    }],
    attrs: {
      "placeholder": "请选择操作摆放位置",
      "disabled": !_vm.private
    },
    domProps: {
      "value": (_vm.operationData.pos)
    },
    on: {
      "input": function($event) {
        _vm.operationData.pos = $event
      }
    }
  }, _vm._l((_vm.position), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "pos"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.currentRouterType === null
    },
    on: {
      "click": function($event) {
        _vm.jump()
      }
    }
  }, [_vm._v("快速访问")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-46a52b57!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/classify/operationConfig.vue
// module id = 1844
// module chunks = 2